import { t } from "@/i18n";
import { returnToTitle } from "@/state/session";
import { backpackTab, lang, openBackpack, panel } from "@/state/store";

/**
 * One-click access to everything a player needs in the world: backpack, quests, progress, help,
 * language and the main menu. Big enough for fingers; labels hide on narrow screens.
 */
export function Toolbar() {
  const open = panel.value;
  const tab = backpackTab.value;
  const is = (target: "equipment" | "quests" | "progress") => open === "backpack" && tab === target;
  return (
    <div class="toolbar" role="toolbar">
      <button
        class={is("equipment") ? "on" : ""}
        title={t("toolbar.backpack.title")}
        onClick={() => openBackpack("equipment")}
      >
        <span class="ico">🎒</span>
        <span class="lbl">{t("toolbar.backpack")}</span>
      </button>
      <button
        class={is("quests") ? "on" : ""}
        title={t("toolbar.quests.title")}
        onClick={() => openBackpack("quests")}
      >
        <span class="ico">📜</span>
        <span class="lbl">{t("toolbar.quests")}</span>
      </button>
      <button
        class={is("progress") ? "on" : ""}
        title={t("toolbar.progress.title")}
        onClick={() => openBackpack("progress")}
      >
        <span class="ico">📊</span>
        <span class="lbl">{t("toolbar.progress")}</span>
      </button>
      <button
        class={open === "help" ? "on" : ""}
        title={t("toolbar.help.title")}
        onClick={() => (panel.value = open === "help" ? null : "help")}
      >
        <span class="ico">❓</span>
        <span class="lbl">{t("toolbar.help")}</span>
      </button>
      <button title={t("backpack.menu")} onClick={returnToTitle}>
        <span class="ico">🏠</span>
        <span class="lbl">{t("toolbar.menu")}</span>
      </button>
      <button
        class="lang"
        title={t("start.language")}
        onClick={() => (lang.value = lang.value === "pl" ? "en" : "pl")}
      >
        {lang.value.toUpperCase()}
      </button>
    </div>
  );
}
